import { useMutation } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import { toast } from "react-toastify";

export const useCreateProject = ({ onCompleted }) => {
  return useMutation({
    mutationKey: ["New-Project-Created"],
    mutationFn: async (body) => {
      let createProjectRes = await apiClient.post(`/api/v10/createProjectUtils/createProject`, body);
      return createProjectRes?.data;
    },
    onSuccess: (successRes) => {
      let status = successRes?.status;
      let message = successRes?.message;
      if (status !== 200) {
        toast.error(`${message}`, { autoClose: 1000, hideProgressBar: false });
      }
      let successMsg = `${successRes?.projectId} - ${message}`;
      toast.success(`${successMsg}`, { autoClose: 1000, hideProgressBar: false });
      onCompleted();
    },
    onError: (errRes) => {
      let errMsg = errRes?.message || errRes?.responce?.data?.message || "Something went Wrong";
      toast.error(`${errMsg}`, { autoClose: 1000, hideProgressBar: false });
    },
  });
};
